/* Product gallery click zones (desktop).

   The prev / next arrow buttons are hidden (see snippets/pp-gallery-zones.liquid). Instead the
   left quarter of the picture steps back, the right quarter steps forward, and the middle half
   still opens the zoom, which is bound on the picture itself (assets/zoom.js).

   A capture-phase listener on the document runs before the zoom's own click handler, so a click
   in a side zone can claim the event (stopPropagation) and the middle is left alone.
   No custom cursors, the zones are simply clickable. Phones are untouched: they swipe. */
(function () {
  'use strict';

  var EDGE = 0.25; // left 25% = previous, right 25% = next, the middle 50% = zoom

  function isDesktop() {
    if (window.theme && typeof window.theme.isMobile === 'function') return !window.theme.isMobile();
    return window.matchMedia('(min-width: 750px)').matches;
  }

  // The gallery this event belongs to, but only when stepping makes sense there:
  // desktop, a fading (thumbnail) gallery, at least two pictures, an image slide.
  function target(event) {
    if (!isDesktop() || !event.target || !event.target.closest) return null;
    var photo = event.target.closest('.product__photo');
    var host = photo && photo.closest('product-images');
    if (!host || !host.hasAttribute('data-fader-desktop')) return null;
    if (host.querySelectorAll('.product__slide').length < 2) return null;
    return { photo: photo, host: host };
  }

  function zoneOf(event, photo) {
    var rect = photo.getBoundingClientRect();
    if (!rect.width) return 'zoom';
    var x = (event.clientX - rect.left) / rect.width;
    return x < EDGE ? 'prev' : x > 1 - EDGE ? 'next' : 'zoom';
  }

  document.addEventListener(
    'click',
    function (event) {
      var hit = target(event);
      if (!hit || hit.host.classList.contains('is-dragging')) return; // a mouse-drag swipe ends with a click too
      var zone = zoneOf(event, hit.photo);
      if (zone === 'zoom') return;

      event.preventDefault();
      event.stopPropagation();
      if (zone === 'prev' && typeof hit.host.showPreviousImage === 'function') hit.host.showPreviousImage();
      if (zone === 'next' && typeof hit.host.showNextImage === 'function') hit.host.showNextImage();
    },
    true
  );

})();
